module.exports = __webpack_public_path__ + "img/sleeve armhole front.ba18bc9b.png";